const getDefaultState = () => {
    return {
        task: {},
        taskActivities: {},
        attachment: {},
        attachmentConstraints: {},
        category: {},
    }
}

const state = getDefaultState()

const getters = {
    // TASK
    tasks(state: any) {
        return state.task
    },

    task: (state: any) => (id: string) => {
        return state.task[id]
    },

    // ATTACHMENTS
    taskAttachments(state: any) {
        return state.attachment
    },

    taskAttachment: (state: any) => (id: string) => {
        return state.attachment[id]
    },

    taskAttachmentConstraints(state: any) {
        return state.attachmentConstraints
    },

    // CATEGORY
    taskCategories(state: any) {
        return state.category
    },

    taskCategory: (state: any) => (id: string) => {
        return state.category[id]
    },
}

const mutations = {
    // TASK
    tasks(state: any, payload: any) {
        state.task = payload
    },

    // ATTACHMENTS
    taskAttachments(state: any, payload: any) {
        state.attachment = payload
    },

    taskAttachmentConstraints(state: any, payload: any) {
        state.attachmentConstraints = payload
    },

    // CATEGORY
    taskCategories(state: any, payload: any) {
        state.category = payload
    },

    //RESET
    resetTask(state: any) {
        const initial: any = getDefaultState()
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key]
        })
    },
}

export default {
    state,
    getters,
    mutations,
}
